export const css = {
	root: '_1yKvaj6r',
	' _key': 'lp-widgets/lpview'
};

export default css;
